import { render, staticRenderFns } from "./UIWrapper.vue?vue&type=template&id=57a0a7ca&scoped=true"
import script from "./UIWrapper.vue?vue&type=script&lang=js"
export * from "./UIWrapper.vue?vue&type=script&lang=js"
import style0 from "./UIWrapper.vue?vue&type=style&index=0&id=57a0a7ca&prod&scoped=true&lang=css"
import style1 from "./UIWrapper.vue?vue&type=style&index=1&id=57a0a7ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a0a7ca",
  null
  
)

export default component.exports